import _ from "lodash";

export default ({ selectedPlan, paymentMethod }) => {
  const foundPaymentMethod = selectedPlan.paymentMethods.find(
    currentPaymentMethod => currentPaymentMethod.type === paymentMethod
  );

  return _.get(foundPaymentMethod, "termTemplateReference", null);
};
